export const makeDeepCopy = (thing: any) => {
    return JSON.parse(JSON.stringify(thing));
}
